import { render, staticRenderFns } from "./JumbotronPage.vue?vue&type=template&id=691472da&scoped=true&"
import script from "./JumbotronPage.vue?vue&type=script&lang=js&"
export * from "./JumbotronPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691472da",
  null
  
)

export default component.exports